import { lazy } from 'react';

export const AdminLanguageEditorPage = lazy(() => import('./AdminLanguageEditorPage'));
